<template>
    <section id="gallery">
        <div class="container-fluid">
            <div class="row" id="main">
                <div class="col-12" style="height: 15vh;">
                    <div class="container-fluid" style="z-index: 1;">
                        <div class="col-12 click-through pl-0 position-fixed" style="z-index:2;">
                            <div><img src="/img/balerija-top-logo.png" width="15%" :class="{ 'mobile-home-img': mobile }" style="margin-top: 1vh;padding-left: 15px;padding-right: 15px;"></div>
                            <router-link to="/#stage" class="back clickable"><span aria-hidden="true" data-icon="," ></span></router-link>
                        </div>
                        <div class="col-12 text-center click-through">
                            <div class="section_title clickable" id="center">
                                SKATUVE
                                <div class="title_nav">
                                <a href="#" class="pasakumi"><div class="dot"></div><div class="title">PASĀKUMI</div></a>
                                <a href="#" class="galerija active"><div class="dot"></div><div class="title">GALERIJA</div></a>
                                <a href="#" class="grupam"><div class="dot"></div><div class="title">GRUPĀM</div></a>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
                <div class="col-12" v-for="(d, i) in months" :key="i">
                    <div class="top-date">{{ monthNames[new Date(d).getMonth()] }} {{ new Date(d).getFullYear() }}</div>
                    <div class="row">
                        <div class="col-2 text-center"></div>
                        <div class="col-10 row" v-if="!mobile">
                            <router-link :to="`/gallery/${g.id}`" class="col-3 gallery" v-for="(g, gIndex) in data" v-if="getMonthNum(g.datums) == getMonthNum(d) && getYear(g.datums) == getYear(d)" :key="gIndex">
                                <div class="date">{{ formatDate(g.datums) }}</div>
                                <div class="title">{{ g.nosaukums }}</div>
                                <img :src="`photos/${g.id}.jpg`" width="100%">
                                <div class="photo_filter"></div>
                                <div class="dot"></div>
                            </router-link>
                        </div>
                        <div class="col-12 row mobile" style="margin-left: 5vw;" v-else>
                            <router-link :to="`/gallery/${g.id}`" class="col-5 gallery" v-for="(g, gIndex) in data" v-if="getMonthNum(g.datums) == getMonthNum(d) && getYear(g.datums) == getYear(d)" :key="gIndex">
                                <div class="date">{{ formatDate(g.datums) }}</div>
                                <div class="title">{{ g.nosaukums }}</div>
                                <img :src="`photos/${g.id}.jpg`" width="100%">
                                <div class="photo_filter"></div>
                                <div class="dot"></div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    </section>
</template>
<script>

export default {
    data()
    {
        return {
            data: null,
            prevMonth: null,
            prevYear: null,
            search: '',
            mobile: false,
            months: [],
            monthNames: ["Janvāris", "Februāris", "Marts", "Aprīlis", "Maijs", "Jūnijs",
                        "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"]
        }
    },
    beforeMount()
    {
        this.loadGallery();
        this.isMobile();
        window.addEventListener('resize', () => {
            this.isMobile();
        });
    },
    methods: {
        isMobile: function()
        {
            if(window.innerWidth < 1280)
                this.mobile = true;
            else
                this.mobile = false;
        },
        loadGallery: function()
        {
            this.$http({
                url: `/gallery`,
                method: 'GET',
            }).then((res) => {
                this.data = res.data;
                
                this.data.forEach(element => {
                    if(this.checkMonthAndYear(element.datums))
                    {
                        this.months.push(element.datums);
                    }
                });

            }, () => {
                this.has_error = true
            })
        },
        checkMonthAndYear: function(date)
        {
            date = new Date(date);
            
            if(date.getMonth() != this.prevMonth || date.getFullYear() != this.prevYear)
            {
                this.prevMonth = date.getMonth();
                this.prevYear = date.getFullYear();
                return true;
            }

            return false;
        },
        getMonthNum: function(date)
        {
            date = new Date(date);

            return date.getMonth();
        },
        getYear: function(date)
        {
            date = new Date(date);

            return date.getFullYear();
        },
        formatDate: function(date)
        {
            date = new Date(date);

            var day = (date.getDate() < 10 ? '0' : '') + date.getDate();
            var month = ((date.getMonth()+1 < 10) ? '0' : '') + (date.getMonth()+1);

            return `${day}.${month}.${date.getFullYear()}`;
        }
    },
    watch: {
        search: function () {
            this.axios.post('/search', {
                value: this.search,
            })
            .then((response) => {
                this.data = response.data;
                
                this.months = [];

                this.data.forEach(element => {
                    if(this.checkMonthAndYear(element.datums))
                    {
                        this.months.push(element.datums);
                    }
                });
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
}
</script>